<template>
  <!-- inline: フッター固定ではなくリスト直下に置く (リストと幅を揃える) -->
  <component :is="inline ? 'div' : 'v-footer'" v-bind="inline ? {} : { app: true }" class="px-2">
    <v-layout align-center justify-space-between>
      <!-- ページ制御 -->
      <v-layout align-center justify-start class="mr-2">
        <v-btn color="accent" height="28px" x-small :disabled="!isEnabledPreviousPage()" @click="previousPage()">
          <v-icon>keyboard_arrow_left</v-icon>
        </v-btn>
        <v-sheet class="transparent">
          <v-select
            v-model="pageNumber"
            single-line
            hide-details
            :items="pageNumberItems"
            class="mx-2 footer-select-box "
            dense
            solo
          />
        </v-sheet>
        <span class="mr-1 caption">
          /
          {{ paginationInfo.totalPages }}
          {{ $tt('customPageSuffix') }}
        </span>
        <v-btn color="accent" height="28px" x-small :disabled="!isEnabledNextPage()" @click="nextPage()">
          <v-icon>keyboard_arrow_right</v-icon>
        </v-btn>
      </v-layout>
      <v-spacer />
      <!-- 表示件数 -->
      <v-layout justify-end align-center class="ml-2">
        <span class="mr-1 caption">{{ $tt('customDisplayCount') }}</span>
        <v-sheet class="transparent">
          <v-select
            v-model="pageSize"
            :items="pageSizeOptions"
            @change="changePageSize()"
            class="mx-2 footer-select-box "
            dense
            solo
            single-line
            hide-details
          />
        </v-sheet>
        <span class="mr-1 caption">
          /
          <span v-if="paginationInfo.totalElements">{{
            $tt('customTotalCount', { count: '' + paginationInfo.totalElements })
          }}</span>
        </span>
      </v-layout>
    </v-layout>
  </component>
</template>
<script>
import * as Constants from '@/lib/constants'
import PagingOptions from '@/lib/paging-options'

export default {
  name: 'PaginationComponent',

  props: {
    paginationInfo: { type: Object, required: true },
    pagingType: { type: String, required: true },
    inline: { type: Boolean, default: false },
  },

  data: () => ({
    pageSize: Constants.DEFAULT_LIST_PAGE_SIZE,
    pageIndex: 0,
    pageSizeOptions: [{ value: 20, text: 20 }, { value: 50, text: 50 }, { value: 100, text: 100 }],
  }),

  computed: {
    pageNumberItems() {
      const totalPages = this.paginationInfo.totalPages
      let pageNumberItems = []
      for (let i = 1; i <= totalPages; i++) {
        pageNumberItems.push(i)
      }
      return pageNumberItems
    },
    pageNumber: {
      get() {
        return this.pageIndex + 1
      },
      set(value) {
        this.pageIndex = value - 1
        const pagingOptions = this.getPagingOptions()
        this.updatePaging(pagingOptions)
      },
    },
  },

  mounted() {
    const pagingOptions = PagingOptions.getPagingOptions(this.pagingType)
    this.pageSize = pagingOptions.pageSize
    this.pageIndex = pagingOptions.pageIndex
  },

  methods: {
    previousPage() {
      if (this.isEnabledPreviousPage()) {
        this.pageIndex--
        const pagingOptions = this.getPagingOptions()
        this.updatePaging(pagingOptions)
      }
    },
    isEnabledPreviousPage() {
      return this.pageNumber > 1
    },
    nextPage() {
      if (this.isEnabledNextPage()) {
        this.pageIndex++
        const pagingOptions = this.getPagingOptions()
        this.updatePaging(pagingOptions)
      }
    },
    isEnabledNextPage() {
      const totalPages = this.paginationInfo.totalPages
      return this.pageNumber < totalPages
    },
    updatePaging(pagingOptions) {
      // 親コンポーネントへ通知（親コンポーネントごとで処理を変える必要があるため）
      this.$emit('update-paging', pagingOptions)
    },
    getPagingOptions() {
      return { pageSize: this.pageSize, page: this.pageIndex }
    },
    changePageSize() {
      this.resetPageIndex()
      const pagingOptions = this.getPagingOptions()
      this.updatePaging(pagingOptions)
    },
    resetPageIndex() {
      this.pageIndex = 0
    },
  },
}
</script>

<style scoped>
.footer-select-box {
  width: 64px;
  font-size: 12px;
}
.footer-select-box ::v-deep .v-input__control {
  min-height: 28px !important;
}
.footer-select-box ::v-deep .v-input__slot {
  min-height: 28px !important;
  padding: 0 0 0 8px !important;
  box-shadow: none !important;
  border: 1px solid rgba(128, 128, 128, 0.4);
}
.footer-select-box ::v-deep .v-input__append-inner {
  margin-top: 2px !important;
}
</style>
